import { Box } from "@drone-js/core";
import { OneOnboardingSkeleton } from "apps/oneOnboarding/Skeleton";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { batchPostPublishSuccessBinder } from "libs/analytics/binders/batchOnboarding/batchPostPublishSuccess";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { BatchFinishIncompleteListings } from "./BatchFinishIncompleteListings";
import { BatchWelcomeMessage } from "./BatchWelcomeMessage";
import { BatchWhatsNext } from "./BatchWhatsNext";
import { useBatchCompletePageViewModel } from "./useBatchCompletePageViewModel";

export const CompletePage = () => {
    const { isLoading } = useBatchCompletePageViewModel();
    useAnalytics(batchPostPublishSuccessBinder);
    const staticData = useStaticDataAtomValue();

    if (staticData === undefined || isLoading) return <OneOnboardingSkeleton />;

    return (
        <Box id="complete-section" maxWidth="848px" mx="auto" data-testid="batch-complete-page">
            <BatchWelcomeMessage />
            <BatchWhatsNext />
            <BatchFinishIncompleteListings />
        </Box>
    );
};
